import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailMachinery } from '../dto/trail-machinery';

@Injectable({
  providedIn: 'root'
})
export class TrailMachineryService {

  private apiUrl = environment.apiRoot + '/trialmachinery';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trialId: number): Observable<TrailMachinery[]> {
    return this.http.get<TrailMachinery[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createMachinery(trialId: number): Observable<TrailMachinery> {
    let model = { "id": 0, "trial_id": trialId, "machinery_name": "new machinery" };
    return this.http.post<TrailMachinery>(this.apiUrl + '/new', model);
  }

  updateMachinery(model: TrailMachinery): Observable<TrailMachinery> {
    return this.http.put<TrailMachinery>(this.apiUrl + '/update', model);
  }

  deleteMachinery(trialMachineryId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialMachineryId=' + trialMachineryId);
  }

}
